import React from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import { useTranslation } from 'react-i18next';

import OthelloModalBase from './OthelloModalBase.jsx';

import { ModoModal } from "../othelloConstantes.jsx";

import { MontarTextoResultadoTraducido } from "../othelloFunciones.jsx";


export default function OthelloMostrarRetorno({ ...props })
{
    const { t, Trans } = useTranslation();

    const {

        resultadoOthello,
        soloIncidencia,        
        open,       
        onCloseResulRetorno,    
        botones,
        textobotones
    } = props;

    let mensaje = "";

    if (!soloIncidencia)
    {
        //Obtengo el mensaje traducido, si es que me viene los valores de traduccion y el resultado es valido y es de tipo CResultaOthello
        mensaje = MontarTextoResultadoTraducido(resultadoOthello, t);

        //Si aun no tenemos mensaje, pero tenemos valor en warning, mostramos el valor warrning
        if (mensaje == null || mensaje == "" && (resultadoOthello != null && resultadoOthello.Warning!= null && resultadoOthello.Warning != ""))
            mensaje = resultadoOthello.Warning;
    }

    //Si llegados hasta aqui no hay mensaje compruebo las incidencias de usuario
    if (mensaje == "")
    {            
        //Si existe alguna incidencia
        if (resultadoOthello.incidencias != null && resultadoOthello.incidencias.length >= 1)
        {           
            resultadoOthello.incidencias.forEach(x =>
            {
                let Resp = "";

                if (x.respuestasUsuario == null || x.respuestasUsuario.Equals(Resp))
                {
                    if (x.paramsLiteralTextoUsuario != null && x.paramsLiteralTextoUsuario.length > 0)
                    {
                        let parametros = " -> ";
                        x.paramsLiteralTextoUsuario.forEach(y => parametros += " | " + y);

                        mensaje = t(x.literalTextoUsuario) + " "+parametros;
                    }
                    else
                        mensaje = t(x.literalTextoUsuario);

                    //mensaje = <Trans i18nKey={x.literalTextoUsuario} components={x.paramsLiteralTextoUsuario[0]}></Trans>
                    //String Msj = Res.ParamsLiteralTextoUsuario != null && Res.ParamsLiteralTextoUsuario.Length > 0 ?
                    //    string.Format(NSClasesOthello.PlugIn.Preferencias.Literales.TomarLiteral(Res.LiteralTextoUsuario, Res.DefaultTextoUsuario),
                    //        Res.ParamsLiteralTextoUsuario) :
                    //    NSClasesOthello.PlugIn.Preferencias.Literales.TomarLiteral(Res.LiteralTextoUsuario, Res.DefaultTextoUsuario);

                    return;
                }
            });
        }          
    }

    //Si tenemos mensaje el retorno, me dvolvera el modal, y sino vacio para que no muestre nada
    return (
        mensaje != "" ?
            <OthelloModalBase tituloliteral="_othello" modo={ModoModal.SinDefinir} open={true} onCloseResulModal={onCloseResulRetorno} botones={botones} textobotones={textobotones} >
            <h6>{mensaje}</h6>
        </OthelloModalBase>  : ""
    );
}

OthelloMostrarRetorno.propTypes = {    
    resultadoOthello: PropTypes.object,
    soloIncidencia: PropTypes.bool, //Si solo debemos tratar la parte de incidencias      
    onCloseResulRetorno: PropTypes.object,
    botones: PropTypes.object,
    textobotones: PropTypes.object
};
